// constants.js
export const navLists = [
  { label: "Über uns", path: "/about" },
  { label: "Dienstleistungen", path: "/services" },
  { label: "Kontakt", path: "/contact" },
//   { label: "Impressum", path: "/impressum" },
];
